import { funnelLog, uploadFunnelLog } from './funnelLog';
import nativeLog from './nativeLog';
import { $getSourcePath, $setPageId, FunnelLogType } from './share';
import { ymstockLog } from './ymstockLog';
import { getClientInfo } from '../getClientInfo';
import { appInfo } from '../appInfo';
import { ProductId } from '../common';
export * from './share';
function normalizePageViewOptions(options) {
    if (options.targetView) {
        options.pageId = options.targetView;
    }
    if (options.attribute) {
        options.pageData = options.attribute;
    }
    if (typeof options.pageData === 'string') {
        try {
            options.pageData = JSON.parse(options.pageData);
        }
        catch (e) {
            console.error('[Log]错误的打点数据，pageData应该为合法的json字符串', options.pageData);
        }
    }
    return options;
}
function normalizeClickOptions(options) {
    if (options.attribute) {
        options.eventData = options.attribute;
    }
    if (typeof options.eventData === 'string') {
        try {
            options.eventData = JSON.parse(options.eventData);
        }
        catch (e) {
            console.error('[Log]错误的打点数据，eventData应该为合法的json字符串', options.eventData);
        }
    }
    return options;
}
export var Log = {
    /**
     * 页面打点
     * @param options
     */
    pageView: function (options) {
        normalizePageViewOptions(options);
        $setPageId(options.pageId);
        // app打点
        nativeLog.pageView(options);
        getClientInfo({
            forceUpdate: false,
            complete: function () {
                // 漏斗打点
                if (!options.disableFunnelLog) {
                    funnelLog({
                        funnelLogType: options.funnelLogType,
                        sourcePath: options.pageId,
                        extraInfo: options.pageData
                    });
                }
                if (appInfo.productId === ProductId.Ymstock) {
                    ymstockLog.pageView(options);
                }
            }
        });
    },
    /**
     * 时间打点
     * @param options
     */
    click: function (options) {
        normalizeClickOptions(options);
        // app打点
        nativeLog.click(options);
        if (!options.disableFunnelLog) {
            funnelLog({
                funnelLogType: options.funnelLogType || FunnelLogType.Click,
                sourcePath: options.eventId,
                extraInfo: options.eventData
            });
        }
        if (appInfo.productId === ProductId.Ymstock) {
            ymstockLog.click(options);
        }
    },
    /**
     * 获取漏斗打点源路径
     */
    getSourcePath: $getSourcePath,
    /**
     * 漏斗打点
     */
    funnelLog: funnelLog,
    /**
     * 经典版打点
     */
    ymstockLog: ymstockLog,
    /**
     * 上传漏斗打点数据
     */
    uploadFunnelLog: uploadFunnelLog
};
//# sourceMappingURL=index.js.map